module.exports = __webpack_public_path__ + "static/media/test-my-stress-logo-new.59a2d11c.svg";